import React from "react";
import {MutualBetslip, useMutualBetslip, useMutualSlipOptions} from "features/betslip/mutual.service";
import {isMobile} from "../../../App";

export function BettingDataTabs(prop: any) {
    const selectBettingColumn = prop.selectBettingColumn;
    useMutualBetslip();
    const options = useMutualSlipOptions();

    if (!options.bettingSubType || !options.bettingType) {
        return (<></>)
    }

    let tabs: any = [];
    for (let i = Number(options.bettingSubType.id); i < Number(options.bettingSubType.id) + options.bettingType.column; i += 1) {
        tabs.push(i)
    }

    let columnType = options.bettingType.columnLabel === 'Koşu' ? 'run' : 'horse';
    let betSlipLegs = MutualBetslip.getLegsSelections();

    return (<>
        <div className="betting-run-tabs badge-tabs">
            <ul className="nav nav-tabs">
                {tabs.map((run: any, keyRun: number) => {
                    let columnNo = keyRun + 1;
                    return (<li key={`runItem-${keyRun}`} className={`nav-item ${columnNo === options.column ? 'active' : ''}`}>
                        <svg className="left" viewBox="0 0 80 60" preserveAspectRatio="none"><use xlinkHref="#tabshape"></use></svg>
                        <a className={`nav-link position-relative ${betSlipLegs[keyRun]?.length > 0 ? 'show-badge' : ''} ${options.bettingType.columnLabel == 'Ayak' && isMobile ? 'ayak' : ''}`} onClick={() => { selectBettingColumn(columnNo) }}>
                            {columnType === 'run' ? options.bettingSubType.label.split('-')[columnNo - 1] : columnNo}{options.bettingType.columnLabel == 'Ayak' && isMobile ? columnNo === options.column && `.${options.bettingType.columnLabel}` : `.${options.bettingType.columnLabel}`}
                            {betSlipLegs[keyRun]?.length > 0 &&
                                <span className={"tab-badge"}>
                {betSlipLegs[keyRun].length}
              </span>}
                        </a>
                        <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlinkHref="#tabshape"></use></svg>
                    </li>)
                })}
            </ul>
        </div>
    </>)
}
